import { render, staticRenderFns } from "./newintervention.vue?vue&type=template&id=9f20f444&scoped=true&"
import script from "./newintervention.vue?vue&type=script&lang=js&"
export * from "./newintervention.vue?vue&type=script&lang=js&"
import style0 from "./newintervention.vue?vue&type=style&index=0&id=9f20f444&lang=scss&scoped=true&"
import style1 from "./newintervention.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9f20f444",
  null
  
)

export default component.exports